module.exports = __webpack_public_path__ + "static/img/k6.dc1434fd.png";